import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { IPetsDashboardResponseModel } from "../../../../typings/models/PetsDashboardResponseModel";
import Header from "../../../../components/molecules/Header/Header";
import Container from "../../../../components/layout/Container/Container";
import Banner from "../../../../components/layout/Sections/Banner";
import PetsGrid from "./PetsGrid";
import PetsRegGrid from "./PetsRegGrid";
import PetsRegOwnerTransferGrid from "./PetsRegOwnerTransferGrid";
import {
  getAllPendingPetsRegistrations,
  getAllPetsRegistrations,
  getAllLostAndFoundPets,
} from "../../../../api/apimethods";
import { useLocation } from "react-router-dom";
import LostAndFoundPetsGrid from "./LostAndFoundPetsGrid";
import {
  AppContext,
  defaultAppContextData,
} from "../../../../services/appData";
import { useAuthService, useContextService } from "../../../../services";

const PetsDashboard: React.FC<{
  RegistrationType: string;
  transferType: string;
}> = ({ RegistrationType, transferType }) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const [data, setData] = useState<any[]>([]);
  const [petRegData, setPetRegData] = useState<any[]>([]);
  const [petData, setPetData] = useState<any[]>([]);
  const [lostPetData, setLostPetData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isTransferData, setTransferData] = useState(true);
  const [banner, setBanner] = useState("");
  const [isHeaders, setIsHeaders] = useState([
    { columnName: "Pets Application Type", sortKey: "applicationType" },
    { columnName: "Animal Type", sortKey: "animalType" },
    { columnName: "Breed", sortKey: "breed" },
    { columnName: "Microchip No.", sortKey: "petsMicrochipNo" },
    { columnName: "Pets Name", sortKey: "petsName" },
    { columnName: "Pets origin", sortKey: "petsOrigin" },
    { columnName: "Owner Name", sortKey: "ownerName" },
    { columnName: "Pet Status", sortKey: "petStatus" },
    { columnName: "Registration Status", sortKey: "registrationStatusString" },
    { columnName: "Owner Edit", buttonCondition: "SomeStatus" },
    { columnName: "Submitted Date", sortKey: "status" },
  ]);

  const location = useLocation();

  const headerColumns = [
    { columnName: "Application No", sortKey: "referenceNo" },
    { columnName: "Pets Application Type", sortKey: "applicationType" },
    { columnName: "New Owner Name", sortKey: "newOwnerName" },
    { columnName: "Microchip No.", sortKey: "petsMicrochipNo" },
    { columnName: "Owner Name", sortKey: "ownerName" },
    { columnName: "Status", sortKey: "status" },
    { columnName: "Submitted Date", sortKey: "submittedDate" },
  ];
  const petColumns = [
    { columnName: "Registration No", sortKey: "referenceNo" },
    { columnName: "Pets Application Type", sortKey: "applicationType" },
    { columnName: "Animal Type", sortKey: "animalType" },
    { columnName: "Breed", sortKey: "breed" },
    { columnName: "Microchip No.", sortKey: "petsMicrochipNo" },
    { columnName: "Pets Name", sortKey: "petsName" },
    { columnName: "Pets origin", sortKey: "petsOrigin" },
    { columnName: "Owner Name", sortKey: "ownerName" },
    { columnName: "Pet Status", sortKey: "petStatus" },
    { columnName: "Registration Status", sortKey: "registrationStatusString" },
    { columnName: "Submitted Date", sortKey: "submittedDate" },
  ];
  const petHeaderColumns = [
    { columnName: "Registration No", sortKey: "referenceNo" },
    { columnName: "Pets Application Type", sortKey: "applicationType" },
    { columnName: "Animal Type", sortKey: "animalType" },
    { columnName: "Breed", sortKey: "breed" },
    { columnName: "Microchip No.", sortKey: "petsMicrochipNo" },
    { columnName: "Pets Name", sortKey: "petsName" },
    { columnName: "Pets origin", sortKey: "petsOrigin" },
    { columnName: "Owner Name", sortKey: "ownerName" },
    { columnName: "Registration Status", sortKey: "petStatus" },
    { columnName: "Submitted Date", sortKey: "submittedDate" },
    // Add other header columns here
  ];

  const LostAndFoundpetHeaderColumns = [
    { columnName: "Application ID", sortKey: "applicationID" },
    { columnName: "Applicant Name", sortKey: "applicantName" },
    { columnName: "Applicant ID Type", sortKey: "applicantIdType" },
    { columnName: "Applicant ID Number", sortKey: "applicantIdNumber" },
    { columnName: "Location of Pet", sortKey: "locationWherePetIsFound" },
    { columnName: "Remarks", sortKey: "remarks" },
    { columnName: "Applicant Mobile Number", sortKey: "applicantMobileNumber" },
    { columnName: "Applicant Email Address", sortKey: "applicantEmailAddress" },
    { columnName: "Pet found date and time", sortKey: "dateWhenPetWasFound" },
    { columnName: "Microchip Number", sortKey: "microchipNo" },
    { columnName: "Description Of Pet", sortKey: "description" },
    { columnName: "Submitted Date", sortKey: "submittedDate" },
  ];

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllPetsRegistrations(user.idNo, user.email);
      setData(response.data);
      setIsLoading(false);
    
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchPetRegData = async () => {
    try {
      setIsLoading(true);
      var userId = user.idNo;
      if (user.role === "CorpPass") userId = user.uen;
      const responses = await getAllPendingPetsRegistrations(
        userId,
        user.email,
        1
      );
      setPetRegData(responses.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchPendingData = async () => {
    try {
      setIsLoading(true);
      const responses = await getAllPendingPetsRegistrations(
        user.idNo,
        user.email,
        2
      );
      setPetData(responses.data);
      setIsLoading(false);
   
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchLostAndFoundData = async () => {
    try {
      setIsLoading(true);
      const responses = await getAllLostAndFoundPets(user.idNo, user.email);
      setLostPetData(responses.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    switch (transferType) {
      case "Pets":
        setBanner("Pets all registrations");
        setIsHeaders(petColumns);
        setTransferData(true);
        fetchData();
        break;
      case "PetsRegistration":
        setBanner("Pets all registrations");
        setIsHeaders(petHeaderColumns);
        setTransferData(true);
        fetchPetRegData();
        break;
      case "PetsPendingRegistration":
        setBanner("Pets all pending registrations");
        setIsHeaders(headerColumns);
        setTransferData(false);
        fetchPendingData();
        break;
      case "LostAndFoundPets":
        setBanner("List of Lost and Found Pets");
        setIsHeaders(LostAndFoundpetHeaderColumns);
        setTransferData(false);
        fetchLostAndFoundData();
        break;
      default:
        break;
    }
  }, [transferType]);

  return (
    <>
      <Container>
        <div>
          {transferType === "Pets" && (
            <PetsGrid
              data={data}
              isLoading={isLoading}
              headerColumns={isHeaders}
              setData={setData}
            />
          )}
          {transferType === "PetsRegistration" && (
            <PetsRegGrid
              data={petRegData}
              isLoading={isLoading}
              headerColumns={isHeaders}
              setData={setPetRegData}
            />
          )}
          {transferType === "PetsPendingRegistration" && (
            <PetsRegOwnerTransferGrid
              data={petData}
              isLoading={isLoading}
              headerColumns={isHeaders}
              setData={setPetData}
            />
          )}
          {transferType === "LostAndFoundPets" && (
            <LostAndFoundPetsGrid
              data={lostPetData}
              isLoading={isLoading}
              headerColumns={isHeaders}
            />
          )}
        </div>
      </Container>
    </>
  );
};

export default PetsDashboard;
